var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
    stroke: "#393B42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37649 13.7823C9.21153 13.9591 8.91829 13.8086 8.9657 13.5715L9.35997 11.6001C9.38305 11.4847 9.31908 11.3697 9.2089 11.3283L7.67224 10.7521C7.35204 10.632 7.25653 10.2251 7.48987 9.97514L10.6235 6.61767C10.7885 6.44093 11.0817 6.59143 11.0343 6.82849L10.64 8.79987C10.6169 8.91525 10.6809 9.03035 10.7911 9.07166L12.3278 9.64791C12.648 9.76799 12.7435 10.1749 12.5101 10.4249L9.37649 13.7823Z",
    fill: "#393B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvance);
export default __webpack_public_path__ + "static/media/advance.f9a14382174ff025c02a918acf695c30.svg";
export { ForwardRef as ReactComponent };